/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const limitCharacters = function () {
  $('form')
    .find('textarea[data-character-limit]')
    .each(function () {
      const characterLimit = $(this).data('character-limit');
      const charCountHtml = String.format(
        SmartOrderRefillSettings.Resources.CHAR_LIMIT_MSG,
        '<span class="char-remain-count">' + characterLimit + '</span>',
        '<span class="char-allowed-count">' + characterLimit + '</span>'
      );
      let charCountContainer = $(this).next('div.char-count');
      if (charCountContainer.length === 0) {
        charCountContainer = $('<div class="char-count"/>').insertAfter($(this));
      }
      charCountContainer.html(charCountHtml);
      // trigger the keydown event so that any existing character data is calculated
      $(this).change();
    });
};

module.exports = {
  limitCharacters: limitCharacters
};
